import { render, staticRenderFns } from "./UpLogs.vue?vue&type=template&id=53a15f1d&scoped=true&"
import script from "./UpLogs.vue?vue&type=script&lang=js&"
export * from "./UpLogs.vue?vue&type=script&lang=js&"
import style0 from "./UpLogs.vue?vue&type=style&index=0&id=53a15f1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a15f1d",
  null
  
)

export default component.exports